var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 6.5V5.16667C5.33301 3.69391 6.52692 2.5 7.99967 2.5C9.47243 2.5 10.6663 3.69391 10.6663 5.16667V6.5M5.46634 14.5H10.533C11.2797 14.5 11.6531 14.5 11.9383 14.3547C12.1892 14.2268 12.3932 14.0229 12.521 13.772C12.6663 13.4868 12.6663 13.1134 12.6663 12.3667V8.63333C12.6663 7.8866 12.6663 7.51323 12.521 7.22801C12.3932 6.97713 12.1892 6.77316 11.9383 6.64532C11.6531 6.5 11.2797 6.5 10.533 6.5H5.46634C4.7196 6.5 4.34624 6.5 4.06102 6.64532C3.81014 6.77316 3.60616 6.97713 3.47833 7.22801C3.33301 7.51323 3.33301 7.8866 3.33301 8.63333V12.3667C3.33301 13.1134 3.33301 13.4868 3.47833 13.772C3.60616 14.0229 3.81014 14.2268 4.06102 14.3547C4.34624 14.5 4.7196 14.5 5.46634 14.5Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.c5e48dfb381f953072f058b15f8d95d5.svg";
export { ForwardRef as ReactComponent };